import React from "react";
import Breadcrumb from "../../utils/Breadcrumb";
import { GetAccess } from "../../utils/RolesandAccess";
import { AddIcon, ExportIcon, ImportIcon } from "../../assets/icons";
import ToggleViews from "../../utils/ToggleViews";
import Pagination from "../../utils/Pagination";
import { TableLoader } from "../Loader";
import PagenationWithApprove from "../../utils/PagenationWithApprove";

function ViewTableIndex({
  standardName = "",
  label = "",
  menu = "",
  children,
  total,
  pageIndex,
  setPageIndex = () => {},
  dataCount,
  setDataCount = () => {},
  information = "",
  CreateAccess = "",
  ExportAccess="",
  ImportAccess="",
  hasExport=false,
  hasImport=false,
  ExportFunction=()=>{},
  ImportFunction=()=>{},
  setOpenForm = () => {},
  hasOverAll=false,
  OverAllPercentage=0,
  isLoading= true,
  header=[],
  hasApprove=false,
  hasFilter=false,
  filterValue="",
  clearFunction=()=>{},
  ReviewStatus=false,
  ReviewFunction=()=>{},
}) {
  return (
    <div className="w-full h-full mx-auto">
      <div className="w-[93%] flex justify-start items-center gap-x-6 pb-1 px-3 mx-auto">
        <Breadcrumb
          items={[
            {
              name: "Standard",
              link:"/main/standard"
            },
            {
              name: standardName,
            },
            {
              name: menu,
            },
            {
              name: label,
            },
          ]}
        />
      </div>
      <div className="w-[96%] mx-auto h-[calc(100vh-105px)] py-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-2xl overflow-y-auto">
        <div className=" h-9 flex justify-between items-center w-full px-4">
          <p className="text-xs 2xl:text-sm text-text">
            {label}{" "}
            {information != "" && (
              <span className=" w-[94.3%] mx-auto text-[13px] text-slate-500">
                {" "}
                : {information}
              </span>
            )}
          </p>
          {
            hasOverAll == true && (
              <div className="flex items-center text-xs 2xl:text-sm">
              <p className="mr-2">overall</p>
              <span className="bg-login px-2 py-1 rounded-md">
                {OverAllPercentage || 0}%
              </span>
            </div>
            )
          }
          <div className=" flex gap-3 justify-center items-center">
            {
              hasFilter == true && (
                <>
                 {
                  (filterValue) && (<div
                    className=" py-1 px-2 rounded-md bg-slate-400 text-xs text-white cursor-pointer"
                    onClick={clearFunction}
                  >
                    clear
                  </div>)
                 }
                </>
              )
            }
          
              {GetAccess(ExportAccess) && (hasExport == true) &&  (
                <div className=" w-7 h-7 flex justify-center items-center rounded bg-primary cursor-pointer">
                <span onClick={() => ExportFunction()}>
                  <ExportIcon width="18px" height="18px" />
                </span>
                </div>
              )}
            

              {GetAccess(ImportAccess) && (hasImport == true) &&  (
                <div className=" w-7 h-7 flex justify-center items-center rounded bg-primary cursor-pointer">
                <span onClick={() => ImportFunction()}>
                  <ImportIcon width="16.5px" height="16.5px"   />
                </span>
                </div>
              )}
            
            <div className=" w-7">
              {GetAccess(CreateAccess) && (
                <span onClick={() => setOpenForm(true)}>
                  <AddIcon />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className=" h-[calc(100vh-194px)] w-full">
        <div className=" w-full h-[calc(100vh-190px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm ">
                  {header?.map((header) => (
                    <th
                      className={`text-center font-medium px-2  py-4 ${header.width}`}
                    >
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(9)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                {children}    
                </>
              )}
            </table>
          </div>
        </div>
        </div>
        <div className=" h-8 flex justify-between items-center w-full px-4">
          {
            hasApprove == true ? (<>
            <PagenationWithApprove
            total={total}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            dataCount={dataCount}
            setDataCount={setDataCount}
            OverAllPercentage={OverAllPercentage}
            ReviewFunction={ReviewFunction}
            ReviewStatus={ReviewStatus}
            isLoading={isLoading}
          />
            </>):(<>
              <Pagination
            total={total}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            dataCount={dataCount}
            setDataCount={setDataCount}
          />  
            </>)
          }
        </div>
      </div>
    </div>
  );
}

export default ViewTableIndex;
